import { Button, styled, Typography } from '@mui/material';

import AuthModal from 'components/system/AuthModal/AuthModal';
import { LoadingButton } from 'components/system/buttons';
import { useEmailVerification } from '../hooks/useEmailVerification';
import { SetupAccountModal } from './common/SetupAccountModal';

const LinkButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  fontSize: theme.typography.textSm.fontSize,
  textDecoration: 'underline',
  boxShadow: 'none',
  padding: '0',

  ':hover': {
    textDecoration: 'underline',
  },
}));

export const EmailVerificationModal = () => {
  const {
    handleAlreadyVerified,
    handleBackToLogin,
    handleResendEmail,
    loading,
    prefilledEmail,
  } = useEmailVerification();

  return (
    <SetupAccountModal open={true} handleBackToLogin={handleBackToLogin}>
      <AuthModal.Content>
        <AuthModal.Title sx={{ marginBottom: 3 }}>
          Email Verification
        </AuthModal.Title>
        <Typography variant="textXl" sx={{ marginBottom: 5 }} paragraph>
          Please check your email to verify your account {prefilledEmail}.
          Follow the link we sent.
        </Typography>
        <Typography variant="textSm">
          Didn't receive the email?{' '}
          <LinkButton variant="text" onClick={handleResendEmail}>
            Resend email
          </LinkButton>
        </Typography>
      </AuthModal.Content>
      <AuthModal.Buttons>
        <LoadingButton onClick={handleAlreadyVerified} loading={loading}>
          Already verified
        </LoadingButton>
      </AuthModal.Buttons>
    </SetupAccountModal>
  );
};
